<div class="profile-dropdown">

  <!-- ── Bouton toggle ── -->
  <button
    type="button"
    class="profile-toggle"
    [class.active]="isClicked"
    aria-haspopup="true"
    [attr.aria-expanded]="isClicked"
    (click)="onClickProfile()"
  >
    <div class="avatar">
      <span class="avatar-initials">{{ initials }}</span>
    </div>

    <div class="profile-info">
      <div class="profile-name">{{ nom }} {{ prenoms }}</div>
      <div class="profile-role">
        <span class="role-dot"></span>
        {{ profil }}
      </div>
    </div>

    <mat-icon class="chevron">keyboard_arrow_down</mat-icon>
  </button>

  <!-- ── Panneau dropdown ── -->
  <div
    *ngIf="isClicked"
    class="dropdown-box"
    role="menu"
    aria-label="Menu profil"
  >

    <!-- En-tête identité -->
    <div class="dropdown-header">
      <div class="avatar avatar--lg">
        <span class="avatar-initials">{{ initials }}</span>
      </div>
      <div class="dropdown-header-info">
        <div class="dropdown-header-name">{{ nom }} {{ prenoms }}</div>
        <div class="dropdown-header-role">
          <span class="role-dot"></span>
          {{ profil }}
        </div>
      </div>
    </div>

    <!-- Items de navigation -->
    <div class="dropdown-body">
      <ng-container *ngFor="let it of menuItems">
        <a
          *ngIf="it.route"
          class="dropdown-item"
          role="menuitem"
          [routerLink]="[it.route]"
          (click)="isClicked = false"
        >
          <span class="item-icon-wrap">
            <mat-icon class="item-icon">{{ it.icon }}</mat-icon>
          </span>
          <span class="item-label">{{ it.label }}</span>
          <span *ngIf="it.badge" class="item-badge">{{ it.badge }}</span>
          <mat-icon class="item-arrow">chevron_right</mat-icon>
        </a>
      </ng-container>
    </div>

    <!-- Pied : déconnexion -->
    <div class="dropdown-footer">
      <ng-container *ngFor="let it of menuItems">
        <app-ui-button
          *ngIf="it.action === 'logout'"
          class="btn-logout-wrap"
          role="menuitem"
          [label]="it.label"
          [iconLeft]="it.icon"
          variant="ghost"
          (clicked)="logoutProfile()"
        ></app-ui-button>
      </ng-container>
    </div>

  </div>
</div>